import IVideoSource from './IVideoSource';
import AspectRatio from '../../base/AspectRatio';

export default interface IVideo {
	aspectRatio?: AspectRatio;
	width?: number;
	height?: number;
	sources: IVideoSource[];
	poster?: string;
}

// Type Guard
export function isVideo(object: any | IVideo): object is IVideo {
	return (
		object &&
		!!(object as IVideo).sources &&
		(object as IVideo).sources.length > 0 &&
		!!(object as IVideo).sources[0].src
	);
}
